import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { CustomMessageModal, CustomMessagesList } from '../../../../../containers/Estate/Store/CustomMessages'
import { NotesBoard, NotesHeader, NotesBody } from '../Store.styles'

function Board({ storeCode, t }) {
    return (
        <NotesBoard>
            <NotesHeader>
                {t('device-custom-messages-list')}
                <CustomMessageModal storeCode={storeCode} />
            </NotesHeader>
            <NotesBody>
                <CustomMessagesList storeCode={storeCode} />
            </NotesBody>
        </NotesBoard>
    )
}

Board.propTypes = {
    storeCode: PropTypes.string,
    t: PropTypes.func.isRequired,
}

Board.defaultProps = {
    storeCode: null,
}

export default withTranslation()(Board)
